import { Box, Skeleton, Stack } from "@mui/material";

export const HomeSkeleton: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 1440, margin: "0 auto" }}>
      {/* Welcome heading */}
      <Skeleton
        variant="text"
        animation="wave"
        sx={{ fontSize: "32px", width: 360, mb: 4 }}
      />

      {/* HomeBanner area */}
      <Skeleton
        variant="rounded"
        animation="wave"
        height={200}
        sx={{ mb: 5, borderRadius: 2 }}
      />

      {/* Section title (My Assignments) */}
      <Skeleton
        variant="text"
        animation="wave"
        sx={{ fontSize: "24px", width: 220, mb: 3 }}
      />

      {/* Filter chips row */}
      <Stack direction="row" spacing={1.5} sx={{ mb: 3, flexWrap: "wrap" }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            animation="wave"
            width={110}
            height={36}
            sx={{ borderRadius: 999 }}
          />
        ))}
      </Stack>

      {/* Assignment cards grid */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 3,
        }}
      >
        {Array.from({ length: 6 }).map((_, i) => (
          <Stack key={i} spacing={1.5}>
            <Skeleton
              variant="rounded"
              animation="wave"
              height={160}
              sx={{ borderRadius: 2 }}
            />
            <Skeleton
              variant="text"
              animation="wave"
              sx={{ fontSize: "18px", width: "80%" }}
            />
            <Skeleton
              variant="text"
              animation="wave"
              sx={{ fontSize: "14px", width: "55%" }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              height={8}
              sx={{ borderRadius: 4, mt: 0.5 }}
            />
          </Stack>
        ))}
      </Box>
    </Box>
  );
};
